// This file is generated by `gulp generate-api`
'use strict';

exports.__esModule = true;
exports.fetchApplicationConstraints = fetchApplicationConstraints;
exports.fetchApplicationConstraintsReset = fetchApplicationConstraintsReset;
exports.fetchApplicationFirstLoanOffer = fetchApplicationFirstLoanOffer;
exports.fetchApplicationFirstLoanOfferReset = fetchApplicationFirstLoanOfferReset;
exports.fetchClient = fetchClient;
exports.fetchClientReset = fetchClientReset;
exports.fetchClientAdditionalData = fetchClientAdditionalData;
exports.fetchClientAdditionalDataReset = fetchClientAdditionalDataReset;
exports.fetchClientApplication = fetchClientApplication;
exports.fetchClientApplicationReset = fetchClientApplicationReset;
exports.fetchClientApplicationConstraints = fetchClientApplicationConstraints;
exports.fetchClientApplicationConstraintsReset = fetchClientApplicationConstraintsReset;
exports.fetchClientApplicationMonthlyPayment = fetchClientApplicationMonthlyPayment;
exports.fetchClientApplicationMonthlyPaymentReset = fetchClientApplicationMonthlyPaymentReset;
exports.fetchClientApplicationOffer = fetchClientApplicationOffer;
exports.fetchClientApplicationOfferReset = fetchClientApplicationOfferReset;
exports.fetchClientBankAccountNumber = fetchClientBankAccountNumber;
exports.fetchClientBankAccountNumberReset = fetchClientBankAccountNumberReset;
exports.fetchClientBanks = fetchClientBanks;
exports.fetchClientBanksReset = fetchClientBanksReset;
exports.fetchClientConsents = fetchClientConsents;
exports.fetchClientConsentsReset = fetchClientConsentsReset;
exports.fetchClientEmail = fetchClientEmail;
exports.fetchClientEmailReset = fetchClientEmailReset;
exports.fetchClientIdentityDocument = fetchClientIdentityDocument;
exports.fetchClientIdentityDocumentReset = fetchClientIdentityDocumentReset;
exports.fetchClientLoans = fetchClientLoans;
exports.fetchClientLoansReset = fetchClientLoansReset;
exports.fetchClientLoansByLoanid = fetchClientLoansByLoanid;
exports.fetchClientLoansByLoanidReset = fetchClientLoansByLoanidReset;
exports.fetchClientLoansPaymentScheduleByLoanid = fetchClientLoansPaymentScheduleByLoanid;
exports.fetchClientLoansPaymentScheduleByLoanidReset = fetchClientLoansPaymentScheduleByLoanidReset;
exports.fetchClientPhone = fetchClientPhone;
exports.fetchClientPhoneReset = fetchClientPhoneReset;
exports.fetchClientProfile = fetchClientProfile;
exports.fetchClientProfileReset = fetchClientProfileReset;
exports.fetchClientSettings = fetchClientSettings;
exports.fetchClientSettingsReset = fetchClientSettingsReset;
exports.fetchDictionaryCountries = fetchDictionaryCountries;
exports.fetchDictionaryCountriesReset = fetchDictionaryCountriesReset;
exports.fetchDictionaryEmploymentStatuses = fetchDictionaryEmploymentStatuses;
exports.fetchDictionaryEmploymentStatusesReset = fetchDictionaryEmploymentStatusesReset;
exports.fetchDictionaryIndustries = fetchDictionaryIndustries;
exports.fetchDictionaryIndustriesReset = fetchDictionaryIndustriesReset;
exports.sendClientApplication = sendClientApplication;
exports.sendClientApplicationReset = sendClientApplicationReset;
exports.sendClientCookies = sendClientCookies;
exports.sendClientCookiesReset = sendClientCookiesReset;
exports.sendClientEmail = sendClientEmail;
exports.sendClientEmailReset = sendClientEmailReset;
exports.sendClientIdentityDocument = sendClientIdentityDocument;
exports.sendClientIdentityDocumentReset = sendClientIdentityDocumentReset;
exports.sendClientPhone = sendClientPhone;
exports.sendClientPhoneReset = sendClientPhoneReset;
exports.sendRegistration = sendRegistration;
exports.sendRegistrationReset = sendRegistrationReset;
exports.patchClientAdditionalData = patchClientAdditionalData;
exports.patchClientAdditionalDataReset = patchClientAdditionalDataReset;
exports.patchClientApplication = patchClientApplication;
exports.patchClientApplicationReset = patchClientApplicationReset;
exports.patchClientApplicationCheck = patchClientApplicationCheck;
exports.patchClientApplicationCheckReset = patchClientApplicationCheckReset;
exports.patchClientConsents = patchClientConsents;
exports.patchClientConsentsReset = patchClientConsentsReset;
exports.patchClientEmailConfirmation = patchClientEmailConfirmation;
exports.patchClientEmailConfirmationReset = patchClientEmailConfirmationReset;
exports.patchClientPassword = patchClientPassword;
exports.patchClientPasswordReset = patchClientPasswordReset;
exports.patchClientPhoneConfirmation = patchClientPhoneConfirmation;
exports.patchClientPhoneConfirmationReset = patchClientPhoneConfirmationReset;
exports.patchClientProfile = patchClientProfile;
exports.patchClientProfileReset = patchClientProfileReset;
exports.patchClientSettings = patchClientSettings;
exports.patchClientSettingsReset = patchClientSettingsReset;
var FETCH_APPLICATION_CONSTRAINTS_SUCCESS = 'FETCH_APPLICATION_CONSTRAINTS_SUCCESS';
exports.FETCH_APPLICATION_CONSTRAINTS_SUCCESS = FETCH_APPLICATION_CONSTRAINTS_SUCCESS;
var FETCH_APPLICATION_CONSTRAINTS_START = 'FETCH_APPLICATION_CONSTRAINTS_START';
exports.FETCH_APPLICATION_CONSTRAINTS_START = FETCH_APPLICATION_CONSTRAINTS_START;
var FETCH_APPLICATION_CONSTRAINTS_ERROR = 'FETCH_APPLICATION_CONSTRAINTS_ERROR';
exports.FETCH_APPLICATION_CONSTRAINTS_ERROR = FETCH_APPLICATION_CONSTRAINTS_ERROR;
var FETCH_APPLICATION_CONSTRAINTS_RESET = 'FETCH_APPLICATION_CONSTRAINTS_RESET';
exports.FETCH_APPLICATION_CONSTRAINTS_RESET = FETCH_APPLICATION_CONSTRAINTS_RESET;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS = FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_START = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_START';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_START = FETCH_APPLICATION_FIRST_LOAN_OFFER_START;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR = FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET = FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET;
var FETCH_CLIENT_ADDITIONAL_DATA_SUCCESS = 'FETCH_CLIENT_ADDITIONAL_DATA_SUCCESS';
exports.FETCH_CLIENT_ADDITIONAL_DATA_SUCCESS = FETCH_CLIENT_ADDITIONAL_DATA_SUCCESS;
var FETCH_CLIENT_ADDITIONAL_DATA_START = 'FETCH_CLIENT_ADDITIONAL_DATA_START';
exports.FETCH_CLIENT_ADDITIONAL_DATA_START = FETCH_CLIENT_ADDITIONAL_DATA_START;
var FETCH_CLIENT_ADDITIONAL_DATA_ERROR = 'FETCH_CLIENT_ADDITIONAL_DATA_ERROR';
exports.FETCH_CLIENT_ADDITIONAL_DATA_ERROR = FETCH_CLIENT_ADDITIONAL_DATA_ERROR;
var FETCH_CLIENT_ADDITIONAL_DATA_RESET = 'FETCH_CLIENT_ADDITIONAL_DATA_RESET';
exports.FETCH_CLIENT_ADDITIONAL_DATA_RESET = FETCH_CLIENT_ADDITIONAL_DATA_RESET;
var FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS = 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS = FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS;
var FETCH_CLIENT_APPLICATION_CONSTRAINTS_START = 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_START';
exports.FETCH_CLIENT_APPLICATION_CONSTRAINTS_START = FETCH_CLIENT_APPLICATION_CONSTRAINTS_START;
var FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR = 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR';
exports.FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR = FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR;
var FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET = 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET';
exports.FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET = FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET;
var FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_SUCCESS = 'FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_SUCCESS = FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_SUCCESS;
var FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_START = 'FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_START';
exports.FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_START = FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_START;
var FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_ERROR = 'FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_ERROR';
exports.FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_ERROR = FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_ERROR;
var FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_RESET = 'FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_RESET';
exports.FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_RESET = FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_RESET;
var FETCH_CLIENT_APPLICATION_OFFER_SUCCESS = 'FETCH_CLIENT_APPLICATION_OFFER_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_OFFER_SUCCESS = FETCH_CLIENT_APPLICATION_OFFER_SUCCESS;
var FETCH_CLIENT_APPLICATION_OFFER_START = 'FETCH_CLIENT_APPLICATION_OFFER_START';
exports.FETCH_CLIENT_APPLICATION_OFFER_START = FETCH_CLIENT_APPLICATION_OFFER_START;
var FETCH_CLIENT_APPLICATION_OFFER_ERROR = 'FETCH_CLIENT_APPLICATION_OFFER_ERROR';
exports.FETCH_CLIENT_APPLICATION_OFFER_ERROR = FETCH_CLIENT_APPLICATION_OFFER_ERROR;
var FETCH_CLIENT_APPLICATION_OFFER_RESET = 'FETCH_CLIENT_APPLICATION_OFFER_RESET';
exports.FETCH_CLIENT_APPLICATION_OFFER_RESET = FETCH_CLIENT_APPLICATION_OFFER_RESET;
var FETCH_CLIENT_APPLICATION_SUCCESS = 'FETCH_CLIENT_APPLICATION_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_SUCCESS = FETCH_CLIENT_APPLICATION_SUCCESS;
var FETCH_CLIENT_APPLICATION_START = 'FETCH_CLIENT_APPLICATION_START';
exports.FETCH_CLIENT_APPLICATION_START = FETCH_CLIENT_APPLICATION_START;
var FETCH_CLIENT_APPLICATION_ERROR = 'FETCH_CLIENT_APPLICATION_ERROR';
exports.FETCH_CLIENT_APPLICATION_ERROR = FETCH_CLIENT_APPLICATION_ERROR;
var FETCH_CLIENT_APPLICATION_RESET = 'FETCH_CLIENT_APPLICATION_RESET';
exports.FETCH_CLIENT_APPLICATION_RESET = FETCH_CLIENT_APPLICATION_RESET;
var FETCH_CLIENT_BANKS_SUCCESS = 'FETCH_CLIENT_BANKS_SUCCESS';
exports.FETCH_CLIENT_BANKS_SUCCESS = FETCH_CLIENT_BANKS_SUCCESS;
var FETCH_CLIENT_BANKS_START = 'FETCH_CLIENT_BANKS_START';
exports.FETCH_CLIENT_BANKS_START = FETCH_CLIENT_BANKS_START;
var FETCH_CLIENT_BANKS_ERROR = 'FETCH_CLIENT_BANKS_ERROR';
exports.FETCH_CLIENT_BANKS_ERROR = FETCH_CLIENT_BANKS_ERROR;
var FETCH_CLIENT_BANKS_RESET = 'FETCH_CLIENT_BANKS_RESET';
exports.FETCH_CLIENT_BANKS_RESET = FETCH_CLIENT_BANKS_RESET;
var FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS = 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS';
exports.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS = FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS;
var FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START = 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START';
exports.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START = FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START;
var FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR = 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR';
exports.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR = FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR;
var FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET = 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET';
exports.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET = FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET;
var FETCH_CLIENT_CONSENTS_SUCCESS = 'FETCH_CLIENT_CONSENTS_SUCCESS';
exports.FETCH_CLIENT_CONSENTS_SUCCESS = FETCH_CLIENT_CONSENTS_SUCCESS;
var FETCH_CLIENT_CONSENTS_START = 'FETCH_CLIENT_CONSENTS_START';
exports.FETCH_CLIENT_CONSENTS_START = FETCH_CLIENT_CONSENTS_START;
var FETCH_CLIENT_CONSENTS_ERROR = 'FETCH_CLIENT_CONSENTS_ERROR';
exports.FETCH_CLIENT_CONSENTS_ERROR = FETCH_CLIENT_CONSENTS_ERROR;
var FETCH_CLIENT_CONSENTS_RESET = 'FETCH_CLIENT_CONSENTS_RESET';
exports.FETCH_CLIENT_CONSENTS_RESET = FETCH_CLIENT_CONSENTS_RESET;
var FETCH_CLIENT_EMAIL_SUCCESS = 'FETCH_CLIENT_EMAIL_SUCCESS';
exports.FETCH_CLIENT_EMAIL_SUCCESS = FETCH_CLIENT_EMAIL_SUCCESS;
var FETCH_CLIENT_EMAIL_START = 'FETCH_CLIENT_EMAIL_START';
exports.FETCH_CLIENT_EMAIL_START = FETCH_CLIENT_EMAIL_START;
var FETCH_CLIENT_EMAIL_ERROR = 'FETCH_CLIENT_EMAIL_ERROR';
exports.FETCH_CLIENT_EMAIL_ERROR = FETCH_CLIENT_EMAIL_ERROR;
var FETCH_CLIENT_EMAIL_RESET = 'FETCH_CLIENT_EMAIL_RESET';
exports.FETCH_CLIENT_EMAIL_RESET = FETCH_CLIENT_EMAIL_RESET;
var FETCH_CLIENT_IDENTITY_DOCUMENT_SUCCESS = 'FETCH_CLIENT_IDENTITY_DOCUMENT_SUCCESS';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_SUCCESS = FETCH_CLIENT_IDENTITY_DOCUMENT_SUCCESS;
var FETCH_CLIENT_IDENTITY_DOCUMENT_START = 'FETCH_CLIENT_IDENTITY_DOCUMENT_START';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_START = FETCH_CLIENT_IDENTITY_DOCUMENT_START;
var FETCH_CLIENT_IDENTITY_DOCUMENT_ERROR = 'FETCH_CLIENT_IDENTITY_DOCUMENT_ERROR';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_ERROR = FETCH_CLIENT_IDENTITY_DOCUMENT_ERROR;
var FETCH_CLIENT_IDENTITY_DOCUMENT_RESET = 'FETCH_CLIENT_IDENTITY_DOCUMENT_RESET';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_RESET = FETCH_CLIENT_IDENTITY_DOCUMENT_RESET;
var FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS = 'FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS';
exports.FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS = FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS;
var FETCH_CLIENT_LOANS_BY_LOANID_START = 'FETCH_CLIENT_LOANS_BY_LOANID_START';
exports.FETCH_CLIENT_LOANS_BY_LOANID_START = FETCH_CLIENT_LOANS_BY_LOANID_START;
var FETCH_CLIENT_LOANS_BY_LOANID_ERROR = 'FETCH_CLIENT_LOANS_BY_LOANID_ERROR';
exports.FETCH_CLIENT_LOANS_BY_LOANID_ERROR = FETCH_CLIENT_LOANS_BY_LOANID_ERROR;
var FETCH_CLIENT_LOANS_BY_LOANID_RESET = 'FETCH_CLIENT_LOANS_BY_LOANID_RESET';
exports.FETCH_CLIENT_LOANS_BY_LOANID_RESET = FETCH_CLIENT_LOANS_BY_LOANID_RESET;
var FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS = 'FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS';
exports.FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS = FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS;
var FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_START = 'FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_START';
exports.FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_START = FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_START;
var FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_ERROR = 'FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_ERROR';
exports.FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_ERROR = FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_ERROR;
var FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_RESET = 'FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_RESET';
exports.FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_RESET = FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_RESET;
var FETCH_CLIENT_LOANS_SUCCESS = 'FETCH_CLIENT_LOANS_SUCCESS';
exports.FETCH_CLIENT_LOANS_SUCCESS = FETCH_CLIENT_LOANS_SUCCESS;
var FETCH_CLIENT_LOANS_START = 'FETCH_CLIENT_LOANS_START';
exports.FETCH_CLIENT_LOANS_START = FETCH_CLIENT_LOANS_START;
var FETCH_CLIENT_LOANS_ERROR = 'FETCH_CLIENT_LOANS_ERROR';
exports.FETCH_CLIENT_LOANS_ERROR = FETCH_CLIENT_LOANS_ERROR;
var FETCH_CLIENT_LOANS_RESET = 'FETCH_CLIENT_LOANS_RESET';
exports.FETCH_CLIENT_LOANS_RESET = FETCH_CLIENT_LOANS_RESET;
var FETCH_CLIENT_PHONE_SUCCESS = 'FETCH_CLIENT_PHONE_SUCCESS';
exports.FETCH_CLIENT_PHONE_SUCCESS = FETCH_CLIENT_PHONE_SUCCESS;
var FETCH_CLIENT_PHONE_START = 'FETCH_CLIENT_PHONE_START';
exports.FETCH_CLIENT_PHONE_START = FETCH_CLIENT_PHONE_START;
var FETCH_CLIENT_PHONE_ERROR = 'FETCH_CLIENT_PHONE_ERROR';
exports.FETCH_CLIENT_PHONE_ERROR = FETCH_CLIENT_PHONE_ERROR;
var FETCH_CLIENT_PHONE_RESET = 'FETCH_CLIENT_PHONE_RESET';
exports.FETCH_CLIENT_PHONE_RESET = FETCH_CLIENT_PHONE_RESET;
var FETCH_CLIENT_PROFILE_SUCCESS = 'FETCH_CLIENT_PROFILE_SUCCESS';
exports.FETCH_CLIENT_PROFILE_SUCCESS = FETCH_CLIENT_PROFILE_SUCCESS;
var FETCH_CLIENT_PROFILE_START = 'FETCH_CLIENT_PROFILE_START';
exports.FETCH_CLIENT_PROFILE_START = FETCH_CLIENT_PROFILE_START;
var FETCH_CLIENT_PROFILE_ERROR = 'FETCH_CLIENT_PROFILE_ERROR';
exports.FETCH_CLIENT_PROFILE_ERROR = FETCH_CLIENT_PROFILE_ERROR;
var FETCH_CLIENT_PROFILE_RESET = 'FETCH_CLIENT_PROFILE_RESET';
exports.FETCH_CLIENT_PROFILE_RESET = FETCH_CLIENT_PROFILE_RESET;
var FETCH_CLIENT_SETTINGS_SUCCESS = 'FETCH_CLIENT_SETTINGS_SUCCESS';
exports.FETCH_CLIENT_SETTINGS_SUCCESS = FETCH_CLIENT_SETTINGS_SUCCESS;
var FETCH_CLIENT_SETTINGS_START = 'FETCH_CLIENT_SETTINGS_START';
exports.FETCH_CLIENT_SETTINGS_START = FETCH_CLIENT_SETTINGS_START;
var FETCH_CLIENT_SETTINGS_ERROR = 'FETCH_CLIENT_SETTINGS_ERROR';
exports.FETCH_CLIENT_SETTINGS_ERROR = FETCH_CLIENT_SETTINGS_ERROR;
var FETCH_CLIENT_SETTINGS_RESET = 'FETCH_CLIENT_SETTINGS_RESET';
exports.FETCH_CLIENT_SETTINGS_RESET = FETCH_CLIENT_SETTINGS_RESET;
var FETCH_CLIENT_SUCCESS = 'FETCH_CLIENT_SUCCESS';
exports.FETCH_CLIENT_SUCCESS = FETCH_CLIENT_SUCCESS;
var FETCH_CLIENT_START = 'FETCH_CLIENT_START';
exports.FETCH_CLIENT_START = FETCH_CLIENT_START;
var FETCH_CLIENT_ERROR = 'FETCH_CLIENT_ERROR';
exports.FETCH_CLIENT_ERROR = FETCH_CLIENT_ERROR;
var FETCH_CLIENT_RESET = 'FETCH_CLIENT_RESET';
exports.FETCH_CLIENT_RESET = FETCH_CLIENT_RESET;
var FETCH_DICTIONARY_COUNTRIES_SUCCESS = 'FETCH_DICTIONARY_COUNTRIES_SUCCESS';
exports.FETCH_DICTIONARY_COUNTRIES_SUCCESS = FETCH_DICTIONARY_COUNTRIES_SUCCESS;
var FETCH_DICTIONARY_COUNTRIES_START = 'FETCH_DICTIONARY_COUNTRIES_START';
exports.FETCH_DICTIONARY_COUNTRIES_START = FETCH_DICTIONARY_COUNTRIES_START;
var FETCH_DICTIONARY_COUNTRIES_ERROR = 'FETCH_DICTIONARY_COUNTRIES_ERROR';
exports.FETCH_DICTIONARY_COUNTRIES_ERROR = FETCH_DICTIONARY_COUNTRIES_ERROR;
var FETCH_DICTIONARY_COUNTRIES_RESET = 'FETCH_DICTIONARY_COUNTRIES_RESET';
exports.FETCH_DICTIONARY_COUNTRIES_RESET = FETCH_DICTIONARY_COUNTRIES_RESET;
var FETCH_DICTIONARY_EMPLOYMENT_STATUSES_SUCCESS = 'FETCH_DICTIONARY_EMPLOYMENT_STATUSES_SUCCESS';
exports.FETCH_DICTIONARY_EMPLOYMENT_STATUSES_SUCCESS = FETCH_DICTIONARY_EMPLOYMENT_STATUSES_SUCCESS;
var FETCH_DICTIONARY_EMPLOYMENT_STATUSES_START = 'FETCH_DICTIONARY_EMPLOYMENT_STATUSES_START';
exports.FETCH_DICTIONARY_EMPLOYMENT_STATUSES_START = FETCH_DICTIONARY_EMPLOYMENT_STATUSES_START;
var FETCH_DICTIONARY_EMPLOYMENT_STATUSES_ERROR = 'FETCH_DICTIONARY_EMPLOYMENT_STATUSES_ERROR';
exports.FETCH_DICTIONARY_EMPLOYMENT_STATUSES_ERROR = FETCH_DICTIONARY_EMPLOYMENT_STATUSES_ERROR;
var FETCH_DICTIONARY_EMPLOYMENT_STATUSES_RESET = 'FETCH_DICTIONARY_EMPLOYMENT_STATUSES_RESET';
exports.FETCH_DICTIONARY_EMPLOYMENT_STATUSES_RESET = FETCH_DICTIONARY_EMPLOYMENT_STATUSES_RESET;
var FETCH_DICTIONARY_INDUSTRIES_SUCCESS = 'FETCH_DICTIONARY_INDUSTRIES_SUCCESS';
exports.FETCH_DICTIONARY_INDUSTRIES_SUCCESS = FETCH_DICTIONARY_INDUSTRIES_SUCCESS;
var FETCH_DICTIONARY_INDUSTRIES_START = 'FETCH_DICTIONARY_INDUSTRIES_START';
exports.FETCH_DICTIONARY_INDUSTRIES_START = FETCH_DICTIONARY_INDUSTRIES_START;
var FETCH_DICTIONARY_INDUSTRIES_ERROR = 'FETCH_DICTIONARY_INDUSTRIES_ERROR';
exports.FETCH_DICTIONARY_INDUSTRIES_ERROR = FETCH_DICTIONARY_INDUSTRIES_ERROR;
var FETCH_DICTIONARY_INDUSTRIES_RESET = 'FETCH_DICTIONARY_INDUSTRIES_RESET';
exports.FETCH_DICTIONARY_INDUSTRIES_RESET = FETCH_DICTIONARY_INDUSTRIES_RESET;
var PATCH_CLIENT_ADDITIONAL_DATA_SUCCESS = 'PATCH_CLIENT_ADDITIONAL_DATA_SUCCESS';
exports.PATCH_CLIENT_ADDITIONAL_DATA_SUCCESS = PATCH_CLIENT_ADDITIONAL_DATA_SUCCESS;
var PATCH_CLIENT_ADDITIONAL_DATA_START = 'PATCH_CLIENT_ADDITIONAL_DATA_START';
exports.PATCH_CLIENT_ADDITIONAL_DATA_START = PATCH_CLIENT_ADDITIONAL_DATA_START;
var PATCH_CLIENT_ADDITIONAL_DATA_ERROR = 'PATCH_CLIENT_ADDITIONAL_DATA_ERROR';
exports.PATCH_CLIENT_ADDITIONAL_DATA_ERROR = PATCH_CLIENT_ADDITIONAL_DATA_ERROR;
var PATCH_CLIENT_ADDITIONAL_DATA_RESET = 'PATCH_CLIENT_ADDITIONAL_DATA_RESET';
exports.PATCH_CLIENT_ADDITIONAL_DATA_RESET = PATCH_CLIENT_ADDITIONAL_DATA_RESET;
var PATCH_CLIENT_APPLICATION_CHECK_SUCCESS = 'PATCH_CLIENT_APPLICATION_CHECK_SUCCESS';
exports.PATCH_CLIENT_APPLICATION_CHECK_SUCCESS = PATCH_CLIENT_APPLICATION_CHECK_SUCCESS;
var PATCH_CLIENT_APPLICATION_CHECK_START = 'PATCH_CLIENT_APPLICATION_CHECK_START';
exports.PATCH_CLIENT_APPLICATION_CHECK_START = PATCH_CLIENT_APPLICATION_CHECK_START;
var PATCH_CLIENT_APPLICATION_CHECK_ERROR = 'PATCH_CLIENT_APPLICATION_CHECK_ERROR';
exports.PATCH_CLIENT_APPLICATION_CHECK_ERROR = PATCH_CLIENT_APPLICATION_CHECK_ERROR;
var PATCH_CLIENT_APPLICATION_CHECK_RESET = 'PATCH_CLIENT_APPLICATION_CHECK_RESET';
exports.PATCH_CLIENT_APPLICATION_CHECK_RESET = PATCH_CLIENT_APPLICATION_CHECK_RESET;
var PATCH_CLIENT_APPLICATION_SUCCESS = 'PATCH_CLIENT_APPLICATION_SUCCESS';
exports.PATCH_CLIENT_APPLICATION_SUCCESS = PATCH_CLIENT_APPLICATION_SUCCESS;
var PATCH_CLIENT_APPLICATION_START = 'PATCH_CLIENT_APPLICATION_START';
exports.PATCH_CLIENT_APPLICATION_START = PATCH_CLIENT_APPLICATION_START;
var PATCH_CLIENT_APPLICATION_ERROR = 'PATCH_CLIENT_APPLICATION_ERROR';
exports.PATCH_CLIENT_APPLICATION_ERROR = PATCH_CLIENT_APPLICATION_ERROR;
var PATCH_CLIENT_APPLICATION_RESET = 'PATCH_CLIENT_APPLICATION_RESET';
exports.PATCH_CLIENT_APPLICATION_RESET = PATCH_CLIENT_APPLICATION_RESET;
var PATCH_CLIENT_CONSENTS_SUCCESS = 'PATCH_CLIENT_CONSENTS_SUCCESS';
exports.PATCH_CLIENT_CONSENTS_SUCCESS = PATCH_CLIENT_CONSENTS_SUCCESS;
var PATCH_CLIENT_CONSENTS_START = 'PATCH_CLIENT_CONSENTS_START';
exports.PATCH_CLIENT_CONSENTS_START = PATCH_CLIENT_CONSENTS_START;
var PATCH_CLIENT_CONSENTS_ERROR = 'PATCH_CLIENT_CONSENTS_ERROR';
exports.PATCH_CLIENT_CONSENTS_ERROR = PATCH_CLIENT_CONSENTS_ERROR;
var PATCH_CLIENT_CONSENTS_RESET = 'PATCH_CLIENT_CONSENTS_RESET';
exports.PATCH_CLIENT_CONSENTS_RESET = PATCH_CLIENT_CONSENTS_RESET;
var PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS = 'PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS';
exports.PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS = PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS;
var PATCH_CLIENT_EMAIL_CONFIRMATION_START = 'PATCH_CLIENT_EMAIL_CONFIRMATION_START';
exports.PATCH_CLIENT_EMAIL_CONFIRMATION_START = PATCH_CLIENT_EMAIL_CONFIRMATION_START;
var PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR = 'PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR';
exports.PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR = PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR;
var PATCH_CLIENT_EMAIL_CONFIRMATION_RESET = 'PATCH_CLIENT_EMAIL_CONFIRMATION_RESET';
exports.PATCH_CLIENT_EMAIL_CONFIRMATION_RESET = PATCH_CLIENT_EMAIL_CONFIRMATION_RESET;
var PATCH_CLIENT_PASSWORD_SUCCESS = 'PATCH_CLIENT_PASSWORD_SUCCESS';
exports.PATCH_CLIENT_PASSWORD_SUCCESS = PATCH_CLIENT_PASSWORD_SUCCESS;
var PATCH_CLIENT_PASSWORD_START = 'PATCH_CLIENT_PASSWORD_START';
exports.PATCH_CLIENT_PASSWORD_START = PATCH_CLIENT_PASSWORD_START;
var PATCH_CLIENT_PASSWORD_ERROR = 'PATCH_CLIENT_PASSWORD_ERROR';
exports.PATCH_CLIENT_PASSWORD_ERROR = PATCH_CLIENT_PASSWORD_ERROR;
var PATCH_CLIENT_PASSWORD_RESET = 'PATCH_CLIENT_PASSWORD_RESET';
exports.PATCH_CLIENT_PASSWORD_RESET = PATCH_CLIENT_PASSWORD_RESET;
var PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS = 'PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS';
exports.PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS = PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS;
var PATCH_CLIENT_PHONE_CONFIRMATION_START = 'PATCH_CLIENT_PHONE_CONFIRMATION_START';
exports.PATCH_CLIENT_PHONE_CONFIRMATION_START = PATCH_CLIENT_PHONE_CONFIRMATION_START;
var PATCH_CLIENT_PHONE_CONFIRMATION_ERROR = 'PATCH_CLIENT_PHONE_CONFIRMATION_ERROR';
exports.PATCH_CLIENT_PHONE_CONFIRMATION_ERROR = PATCH_CLIENT_PHONE_CONFIRMATION_ERROR;
var PATCH_CLIENT_PHONE_CONFIRMATION_RESET = 'PATCH_CLIENT_PHONE_CONFIRMATION_RESET';
exports.PATCH_CLIENT_PHONE_CONFIRMATION_RESET = PATCH_CLIENT_PHONE_CONFIRMATION_RESET;
var PATCH_CLIENT_PROFILE_SUCCESS = 'PATCH_CLIENT_PROFILE_SUCCESS';
exports.PATCH_CLIENT_PROFILE_SUCCESS = PATCH_CLIENT_PROFILE_SUCCESS;
var PATCH_CLIENT_PROFILE_START = 'PATCH_CLIENT_PROFILE_START';
exports.PATCH_CLIENT_PROFILE_START = PATCH_CLIENT_PROFILE_START;
var PATCH_CLIENT_PROFILE_ERROR = 'PATCH_CLIENT_PROFILE_ERROR';
exports.PATCH_CLIENT_PROFILE_ERROR = PATCH_CLIENT_PROFILE_ERROR;
var PATCH_CLIENT_PROFILE_RESET = 'PATCH_CLIENT_PROFILE_RESET';
exports.PATCH_CLIENT_PROFILE_RESET = PATCH_CLIENT_PROFILE_RESET;
var PATCH_CLIENT_SETTINGS_SUCCESS = 'PATCH_CLIENT_SETTINGS_SUCCESS';
exports.PATCH_CLIENT_SETTINGS_SUCCESS = PATCH_CLIENT_SETTINGS_SUCCESS;
var PATCH_CLIENT_SETTINGS_START = 'PATCH_CLIENT_SETTINGS_START';
exports.PATCH_CLIENT_SETTINGS_START = PATCH_CLIENT_SETTINGS_START;
var PATCH_CLIENT_SETTINGS_ERROR = 'PATCH_CLIENT_SETTINGS_ERROR';
exports.PATCH_CLIENT_SETTINGS_ERROR = PATCH_CLIENT_SETTINGS_ERROR;
var PATCH_CLIENT_SETTINGS_RESET = 'PATCH_CLIENT_SETTINGS_RESET';
exports.PATCH_CLIENT_SETTINGS_RESET = PATCH_CLIENT_SETTINGS_RESET;
var SEND_CLIENT_APPLICATION_SUCCESS = 'SEND_CLIENT_APPLICATION_SUCCESS';
exports.SEND_CLIENT_APPLICATION_SUCCESS = SEND_CLIENT_APPLICATION_SUCCESS;
var SEND_CLIENT_APPLICATION_START = 'SEND_CLIENT_APPLICATION_START';
exports.SEND_CLIENT_APPLICATION_START = SEND_CLIENT_APPLICATION_START;
var SEND_CLIENT_APPLICATION_ERROR = 'SEND_CLIENT_APPLICATION_ERROR';
exports.SEND_CLIENT_APPLICATION_ERROR = SEND_CLIENT_APPLICATION_ERROR;
var SEND_CLIENT_APPLICATION_RESET = 'SEND_CLIENT_APPLICATION_RESET';
exports.SEND_CLIENT_APPLICATION_RESET = SEND_CLIENT_APPLICATION_RESET;
var SEND_CLIENT_COOKIES_SUCCESS = 'SEND_CLIENT_COOKIES_SUCCESS';
exports.SEND_CLIENT_COOKIES_SUCCESS = SEND_CLIENT_COOKIES_SUCCESS;
var SEND_CLIENT_COOKIES_START = 'SEND_CLIENT_COOKIES_START';
exports.SEND_CLIENT_COOKIES_START = SEND_CLIENT_COOKIES_START;
var SEND_CLIENT_COOKIES_ERROR = 'SEND_CLIENT_COOKIES_ERROR';
exports.SEND_CLIENT_COOKIES_ERROR = SEND_CLIENT_COOKIES_ERROR;
var SEND_CLIENT_COOKIES_RESET = 'SEND_CLIENT_COOKIES_RESET';
exports.SEND_CLIENT_COOKIES_RESET = SEND_CLIENT_COOKIES_RESET;
var SEND_CLIENT_EMAIL_SUCCESS = 'SEND_CLIENT_EMAIL_SUCCESS';
exports.SEND_CLIENT_EMAIL_SUCCESS = SEND_CLIENT_EMAIL_SUCCESS;
var SEND_CLIENT_EMAIL_START = 'SEND_CLIENT_EMAIL_START';
exports.SEND_CLIENT_EMAIL_START = SEND_CLIENT_EMAIL_START;
var SEND_CLIENT_EMAIL_ERROR = 'SEND_CLIENT_EMAIL_ERROR';
exports.SEND_CLIENT_EMAIL_ERROR = SEND_CLIENT_EMAIL_ERROR;
var SEND_CLIENT_EMAIL_RESET = 'SEND_CLIENT_EMAIL_RESET';
exports.SEND_CLIENT_EMAIL_RESET = SEND_CLIENT_EMAIL_RESET;
var SEND_CLIENT_IDENTITY_DOCUMENT_SUCCESS = 'SEND_CLIENT_IDENTITY_DOCUMENT_SUCCESS';
exports.SEND_CLIENT_IDENTITY_DOCUMENT_SUCCESS = SEND_CLIENT_IDENTITY_DOCUMENT_SUCCESS;
var SEND_CLIENT_IDENTITY_DOCUMENT_START = 'SEND_CLIENT_IDENTITY_DOCUMENT_START';
exports.SEND_CLIENT_IDENTITY_DOCUMENT_START = SEND_CLIENT_IDENTITY_DOCUMENT_START;
var SEND_CLIENT_IDENTITY_DOCUMENT_ERROR = 'SEND_CLIENT_IDENTITY_DOCUMENT_ERROR';
exports.SEND_CLIENT_IDENTITY_DOCUMENT_ERROR = SEND_CLIENT_IDENTITY_DOCUMENT_ERROR;
var SEND_CLIENT_IDENTITY_DOCUMENT_RESET = 'SEND_CLIENT_IDENTITY_DOCUMENT_RESET';
exports.SEND_CLIENT_IDENTITY_DOCUMENT_RESET = SEND_CLIENT_IDENTITY_DOCUMENT_RESET;
var SEND_CLIENT_PHONE_SUCCESS = 'SEND_CLIENT_PHONE_SUCCESS';
exports.SEND_CLIENT_PHONE_SUCCESS = SEND_CLIENT_PHONE_SUCCESS;
var SEND_CLIENT_PHONE_START = 'SEND_CLIENT_PHONE_START';
exports.SEND_CLIENT_PHONE_START = SEND_CLIENT_PHONE_START;
var SEND_CLIENT_PHONE_ERROR = 'SEND_CLIENT_PHONE_ERROR';
exports.SEND_CLIENT_PHONE_ERROR = SEND_CLIENT_PHONE_ERROR;
var SEND_CLIENT_PHONE_RESET = 'SEND_CLIENT_PHONE_RESET';
exports.SEND_CLIENT_PHONE_RESET = SEND_CLIENT_PHONE_RESET;
var SEND_REGISTRATION_SUCCESS = 'SEND_REGISTRATION_SUCCESS';
exports.SEND_REGISTRATION_SUCCESS = SEND_REGISTRATION_SUCCESS;
var SEND_REGISTRATION_START = 'SEND_REGISTRATION_START';
exports.SEND_REGISTRATION_START = SEND_REGISTRATION_START;
var SEND_REGISTRATION_ERROR = 'SEND_REGISTRATION_ERROR';
exports.SEND_REGISTRATION_ERROR = SEND_REGISTRATION_ERROR;
var SEND_REGISTRATION_RESET = 'SEND_REGISTRATION_RESET';
exports.SEND_REGISTRATION_RESET = SEND_REGISTRATION_RESET;
/**
* GET /application/constraints
*
* Load response by connectState:
* @connectState({
*   state: {
*     constraints: ['api', 'fetch', 'application', 'constraints', 'query']
*   },
*   actions: {
*     fetchApplicationConstraints: ['api', 'fetchApplicationConstraints']
*   }
* })
*
* In component you can get to query result by:
* this.props.constraints.data    #=> Immutable.Map
* this.props.constraints.fetched #=> boolean
* this.props.constraints.pending #=> boolean
* this.props.constraints.error   #=> null or something returned from action
*
* @method fetchApplicationConstraints
*
* @return {fetchApplicationConstraints} src/common/api/response/fetchApplicationConstraints.js
*/

function fetchApplicationConstraints() {
  return function (_ref) {
    var httpGet = _ref.httpGet;
    return {
      type: 'FETCH_APPLICATION_CONSTRAINTS',
      payload: {
        promise: httpGet('/application/constraints')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchApplicationConstraints()
*/


function fetchApplicationConstraintsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_APPLICATION_CONSTRAINTS_RESET',
    hardReset: hard
  };
}
/**
* GET /application/first-loan-offer
*
* Load response by connectState:
* @connectState({
*   state: {
*     firstLoanOffer: ['api', 'fetch', 'application', 'firstLoanOffer']
*   },
*   actions: {
*     fetchApplicationFirstLoanOffer: ['api', 'fetchApplicationFirstLoanOffer']
*   }
* })
*
* This action returns saves queries to nested structure with [amount, term, productNumber]
* so in component you can get to query result by:
* this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'data'])    #=> Immutable.Map
* this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'fetched']) #=> boolean
* this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'pending']) #=> boolean
* this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).data       #=> Immutable.Map
* this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).fetched    #=> boolean
* this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).pending    #=> boolean
* this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).error      #=> null or something returned from action
*
* @method fetchApplicationFirstLoanOffer
*
* @param  amount         {Int}
* @param  term           {Int}
* @param  productNumber  {String}
*
* @return {fetchApplicationFirstLoanOffer} src/common/api/response/fetchApplicationFirstLoanOffer.js
*/


function fetchApplicationFirstLoanOffer(amount, term, productNumber) {
  return function (_ref2) {
    var httpGet = _ref2.httpGet;
    return {
      type: 'FETCH_APPLICATION_FIRST_LOAN_OFFER',
      meta: {
        amount: amount,
        term: term,
        productNumber: productNumber
      },
      payload: {
        promise: httpGet('/application/first-loan-offer', {
          amount: amount,
          term: term,
          productNumber: productNumber
        })
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchApplicationFirstLoanOffer(amount, term, productNumber)
*/


function fetchApplicationFirstLoanOfferReset(amount, term, productNumber) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET',
    meta: {
      amount: amount,
      term: term,
      productNumber: productNumber
    },
    hardReset: hard
  };
}
/**
* GET /client
*
* Load response by connectState:
* @connectState({
*   state: {
*     client: ['api', 'fetch', 'client', 'query']
*   },
*   actions: {
*     fetchClient: ['api', 'fetchClient']
*   }
* })
*
* In component you can get to query result by:
* this.props.client.data    #=> Immutable.Map
* this.props.client.fetched #=> boolean
* this.props.client.pending #=> boolean
* this.props.client.error   #=> null or something returned from action
*
* @method fetchClient
*
* @return {fetchClient} src/common/api/response/fetchClient.js
*/


function fetchClient() {
  return function (_ref3) {
    var httpGet = _ref3.httpGet;
    return {
      type: 'FETCH_CLIENT',
      payload: {
        promise: httpGet('/client')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClient()
*/


function fetchClientReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_RESET',
    hardReset: hard
  };
}
/**
* GET /client/additional-data
*
* Load response by connectState:
* @connectState({
*   state: {
*     additionalData: ['api', 'fetch', 'client', 'additionalData', 'query']
*   },
*   actions: {
*     fetchClientAdditionalData: ['api', 'fetchClientAdditionalData']
*   }
* })
*
* In component you can get to query result by:
* this.props.additionalData.data    #=> Immutable.Map
* this.props.additionalData.fetched #=> boolean
* this.props.additionalData.pending #=> boolean
* this.props.additionalData.error   #=> null or something returned from action
*
* @method fetchClientAdditionalData
*
*/


function fetchClientAdditionalData() {
  return function (_ref4) {
    var httpGet = _ref4.httpGet;
    return {
      type: 'FETCH_CLIENT_ADDITIONAL_DATA',
      payload: {
        promise: httpGet('/client/additional-data')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientAdditionalData()
*/


function fetchClientAdditionalDataReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_ADDITIONAL_DATA_RESET',
    hardReset: hard
  };
}
/**
* GET /client/application
*
* Load response by connectState:
* @connectState({
*   state: {
*     application: ['api', 'fetch', 'client', 'application', 'query']
*   },
*   actions: {
*     fetchClientApplication: ['api', 'fetchClientApplication']
*   }
* })
*
* In component you can get to query result by:
* this.props.application.data    #=> Immutable.Map
* this.props.application.fetched #=> boolean
* this.props.application.pending #=> boolean
* this.props.application.error   #=> null or something returned from action
*
* @method fetchClientApplication
*
* @return {fetchClientApplication} src/common/api/response/fetchClientApplication.js
*/


function fetchClientApplication() {
  return function (_ref5) {
    var httpGet = _ref5.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION',
      payload: {
        promise: httpGet('/client/application')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientApplication()
*/


function fetchClientApplicationReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_APPLICATION_RESET',
    hardReset: hard
  };
}
/**
* GET /client/application/constraints
*
* Load response by connectState:
* @connectState({
*   state: {
*     constraints: ['api', 'fetch', 'client', 'application', 'constraints', 'query']
*   },
*   actions: {
*     fetchClientApplicationConstraints: ['api', 'fetchClientApplicationConstraints']
*   }
* })
*
* In component you can get to query result by:
* this.props.constraints.data    #=> Immutable.Map
* this.props.constraints.fetched #=> boolean
* this.props.constraints.pending #=> boolean
* this.props.constraints.error   #=> null or something returned from action
*
* @method fetchClientApplicationConstraints
*
* @return {fetchClientApplicationConstraints} src/common/api/response/fetchClientApplicationConstraints.js
*/


function fetchClientApplicationConstraints() {
  return function (_ref6) {
    var httpGet = _ref6.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION_CONSTRAINTS',
      payload: {
        promise: httpGet('/client/application/constraints')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientApplicationConstraints()
*/


function fetchClientApplicationConstraintsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET',
    hardReset: hard
  };
}
/**
* GET /client/application/monthly-payment
*
* Load response by connectState:
* @connectState({
*   state: {
*     monthlyPayment: ['api', 'fetch', 'client', 'application', 'monthlyPayment']
*   },
*   actions: {
*     fetchClientApplicationMonthlyPayment: ['api', 'fetchClientApplicationMonthlyPayment']
*   }
* })
*
* This action returns saves queries to nested structure with [amount, term]
* so in component you can get to query result by:
* this.props.monthlyPayment.getIn([amount.toString(), term.toString(), 'data'])    #=> Immutable.Map
* this.props.monthlyPayment.getIn([amount.toString(), term.toString(), 'fetched']) #=> boolean
* this.props.monthlyPayment.getIn([amount.toString(), term.toString(), 'pending']) #=> boolean
* this.props.monthlyPayment.getIn([amount.toString(), term.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.monthlyPayment.getIn([amount.toString(), term.toString()]).data       #=> Immutable.Map
* this.props.monthlyPayment.getIn([amount.toString(), term.toString()]).fetched    #=> boolean
* this.props.monthlyPayment.getIn([amount.toString(), term.toString()]).pending    #=> boolean
* this.props.monthlyPayment.getIn([amount.toString(), term.toString()]).error      #=> null or something returned from action
*
* @method fetchClientApplicationMonthlyPayment
*
* @param  amount  {Int}
* @param  term    {Int}
*
* @return {fetchClientApplicationMonthlyPayment} src/common/api/response/fetchClientApplicationMonthlyPayment.js
*/


function fetchClientApplicationMonthlyPayment(amount, term) {
  return function (_ref7) {
    var httpGet = _ref7.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT',
      meta: {
        amount: amount,
        term: term
      },
      payload: {
        promise: httpGet('/client/application/monthly-payment', {
          amount: amount,
          term: term
        })
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientApplicationMonthlyPayment(amount, term)
*/


function fetchClientApplicationMonthlyPaymentReset(amount, term) {
  var hard = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
  return {
    type: 'FETCH_CLIENT_APPLICATION_MONTHLY_PAYMENT_RESET',
    meta: {
      amount: amount,
      term: term
    },
    hardReset: hard
  };
}
/**
* GET /client/application/offer
*
* Load response by connectState:
* @connectState({
*   state: {
*     offer: ['api', 'fetch', 'client', 'application', 'offer']
*   },
*   actions: {
*     fetchClientApplicationOffer: ['api', 'fetchClientApplicationOffer']
*   }
* })
*
* This action returns saves queries to nested structure with [amount, term, productNumber]
* so in component you can get to query result by:
* this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'data'])    #=> Immutable.Map
* this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'fetched']) #=> boolean
* this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'pending']) #=> boolean
* this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString()]).data       #=> Immutable.Map
* this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString()]).fetched    #=> boolean
* this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString()]).pending    #=> boolean
* this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString()]).error      #=> null or something returned from action
*
* @method fetchClientApplicationOffer
*
* @param  amount         {Int}
* @param  term           {Int}
* @param  productNumber  {String}
*
* @return {fetchClientApplicationOffer} src/common/api/response/fetchClientApplicationOffer.js
*/


function fetchClientApplicationOffer(amount, term, productNumber) {
  return function (_ref8) {
    var httpGet = _ref8.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION_OFFER',
      meta: {
        amount: amount,
        term: term,
        productNumber: productNumber
      },
      payload: {
        promise: httpGet('/client/application/offer', {
          amount: amount,
          term: term,
          productNumber: productNumber
        })
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientApplicationOffer(amount, term, productNumber)
*/


function fetchClientApplicationOfferReset(amount, term, productNumber) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_CLIENT_APPLICATION_OFFER_RESET',
    meta: {
      amount: amount,
      term: term,
      productNumber: productNumber
    },
    hardReset: hard
  };
}
/**
* GET /client/bank-account-number
*
* Load response by connectState:
* @connectState({
*   state: {
*     bankAccountNumber: ['api', 'fetch', 'client', 'bankAccountNumber', 'query']
*   },
*   actions: {
*     fetchClientBankAccountNumber: ['api', 'fetchClientBankAccountNumber']
*   }
* })
*
* In component you can get to query result by:
* this.props.bankAccountNumber.data    #=> Immutable.Map
* this.props.bankAccountNumber.fetched #=> boolean
* this.props.bankAccountNumber.pending #=> boolean
* this.props.bankAccountNumber.error   #=> null or something returned from action
*
* @method fetchClientBankAccountNumber
*
* @return {fetchClientBankAccountNumber} src/common/api/response/fetchClientBankAccountNumber.js
*/


function fetchClientBankAccountNumber() {
  return function (_ref9) {
    var httpGet = _ref9.httpGet;
    return {
      type: 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER',
      payload: {
        promise: httpGet('/client/bank-account-number')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientBankAccountNumber()
*/


function fetchClientBankAccountNumberReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET',
    hardReset: hard
  };
}
/**
* GET /client/banks
*
* Load response by connectState:
* @connectState({
*   state: {
*     banks: ['api', 'fetch', 'client', 'banks', 'query']
*   },
*   actions: {
*     fetchClientBanks: ['api', 'fetchClientBanks']
*   }
* })
*
* In component you can get to query result by:
* this.props.banks.data    #=> Immutable.Map
* this.props.banks.fetched #=> boolean
* this.props.banks.pending #=> boolean
* this.props.banks.error   #=> null or something returned from action
*
* @method fetchClientBanks
*
* @return {fetchClientBanks} src/common/api/response/fetchClientBanks.js
*/


function fetchClientBanks() {
  return function (_ref10) {
    var httpGet = _ref10.httpGet;
    return {
      type: 'FETCH_CLIENT_BANKS',
      payload: {
        promise: httpGet('/client/banks')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientBanks()
*/


function fetchClientBanksReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_BANKS_RESET',
    hardReset: hard
  };
}
/**
* GET /client/consents
*
* Load response by connectState:
* @connectState({
*   state: {
*     consents: ['api', 'fetch', 'client', 'consents', 'query']
*   },
*   actions: {
*     fetchClientConsents: ['api', 'fetchClientConsents']
*   }
* })
*
* In component you can get to query result by:
* this.props.consents.data    #=> Immutable.Map
* this.props.consents.fetched #=> boolean
* this.props.consents.pending #=> boolean
* this.props.consents.error   #=> null or something returned from action
*
* @method fetchClientConsents
*
* @return {fetchClientConsents} src/common/api/response/fetchClientConsents.js
*/


function fetchClientConsents() {
  return function (_ref11) {
    var httpGet = _ref11.httpGet;
    return {
      type: 'FETCH_CLIENT_CONSENTS',
      payload: {
        promise: httpGet('/client/consents')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientConsents()
*/


function fetchClientConsentsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_CONSENTS_RESET',
    hardReset: hard
  };
}
/**
* GET /client/email
*
* Load response by connectState:
* @connectState({
*   state: {
*     email: ['api', 'fetch', 'client', 'email', 'query']
*   },
*   actions: {
*     fetchClientEmail: ['api', 'fetchClientEmail']
*   }
* })
*
* In component you can get to query result by:
* this.props.email.data    #=> Immutable.Map
* this.props.email.fetched #=> boolean
* this.props.email.pending #=> boolean
* this.props.email.error   #=> null or something returned from action
*
* @method fetchClientEmail
*
* @return {fetchClientEmail} src/common/api/response/fetchClientEmail.js
*/


function fetchClientEmail() {
  return function (_ref12) {
    var httpGet = _ref12.httpGet;
    return {
      type: 'FETCH_CLIENT_EMAIL',
      payload: {
        promise: httpGet('/client/email')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientEmail()
*/


function fetchClientEmailReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_EMAIL_RESET',
    hardReset: hard
  };
}
/**
* GET /client/identity-document
*
* Load response by connectState:
* @connectState({
*   state: {
*     identityDocument: ['api', 'fetch', 'client', 'identityDocument', 'query']
*   },
*   actions: {
*     fetchClientIdentityDocument: ['api', 'fetchClientIdentityDocument']
*   }
* })
*
* In component you can get to query result by:
* this.props.identityDocument.data    #=> Immutable.Map
* this.props.identityDocument.fetched #=> boolean
* this.props.identityDocument.pending #=> boolean
* this.props.identityDocument.error   #=> null or something returned from action
*
* @method fetchClientIdentityDocument
*
* @return {fetchClientIdentityDocument} src/common/api/response/fetchClientIdentityDocument.js
*/


function fetchClientIdentityDocument() {
  return function (_ref13) {
    var httpGet = _ref13.httpGet;
    return {
      type: 'FETCH_CLIENT_IDENTITY_DOCUMENT',
      payload: {
        promise: httpGet('/client/identity-document')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientIdentityDocument()
*/


function fetchClientIdentityDocumentReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_IDENTITY_DOCUMENT_RESET',
    hardReset: hard
  };
}
/**
* GET /client/loans
*
* Load response by connectState:
* @connectState({
*   state: {
*     loans: ['api', 'fetch', 'client', 'loans', 'query']
*   },
*   actions: {
*     fetchClientLoans: ['api', 'fetchClientLoans']
*   }
* })
*
* In component you can get to query result by:
* this.props.loans.data    #=> Immutable.Map
* this.props.loans.fetched #=> boolean
* this.props.loans.pending #=> boolean
* this.props.loans.error   #=> null or something returned from action
*
* @method fetchClientLoans
*
* @return {fetchClientLoans} src/common/api/response/fetchClientLoans.js
*/


function fetchClientLoans() {
  return function (_ref14) {
    var httpGet = _ref14.httpGet;
    return {
      type: 'FETCH_CLIENT_LOANS',
      payload: {
        promise: httpGet('/client/loans')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientLoans()
*/


function fetchClientLoansReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_LOANS_RESET',
    hardReset: hard
  };
}
/**
* GET /client/loans/{loanId: \d+|latest|latest\-all\-statuses}
*
* Load response by connectState:
* @connectState({
*   state: {
*     loans: ['api', 'fetch', 'client', 'loans']
*   },
*   actions: {
*     fetchClientLoansByLoanid: ['api', 'fetchClientLoansByLoanid']
*   }
* })
*
* This action returns saves queries to nested structure with [loanId]
* so in component you can get to query result by:
* this.props.loans.getIn([loanId.toString(), 'data'])    #=> Immutable.Map
* this.props.loans.getIn([loanId.toString(), 'fetched']) #=> boolean
* this.props.loans.getIn([loanId.toString(), 'pending']) #=> boolean
* this.props.loans.getIn([loanId.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.loans.getIn([loanId.toString()]).data       #=> Immutable.Map
* this.props.loans.getIn([loanId.toString()]).fetched    #=> boolean
* this.props.loans.getIn([loanId.toString()]).pending    #=> boolean
* this.props.loans.getIn([loanId.toString()]).error      #=> null or something returned from action
*
* @method fetchClientLoansByLoanid
*
* @param  loanId  {?}
*
* @return {fetchClientLoansByLoanid} src/common/api/response/fetchClientLoansByLoanid.js
*/


function fetchClientLoansByLoanid(loanId) {
  return function (_ref15) {
    var httpGet = _ref15.httpGet;
    return {
      type: 'FETCH_CLIENT_LOANS_BY_LOANID',
      meta: {
        loanId: loanId
      },
      payload: {
        promise: httpGet('/client/loans/' + loanId)
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientLoansByLoanid(loanId)
*/


function fetchClientLoansByLoanidReset(loanId) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_CLIENT_LOANS_BY_LOANID_RESET',
    meta: {
      loanId: loanId
    },
    hardReset: hard
  };
}
/**
* GET /client/loans/{loanId: \d+|latest|latest\-all\-statuses}/payment-schedule
*
* Load response by connectState:
* @connectState({
*   state: {
*     paymentSchedule: ['api', 'fetch', 'client', 'loans', 'paymentSchedule']
*   },
*   actions: {
*     fetchClientLoansPaymentScheduleByLoanid: ['api', 'fetchClientLoansPaymentScheduleByLoanid']
*   }
* })
*
* This action returns saves queries to nested structure with [loanId]
* so in component you can get to query result by:
* this.props.paymentSchedule.getIn([loanId.toString(), 'data'])    #=> Immutable.Map
* this.props.paymentSchedule.getIn([loanId.toString(), 'fetched']) #=> boolean
* this.props.paymentSchedule.getIn([loanId.toString(), 'pending']) #=> boolean
* this.props.paymentSchedule.getIn([loanId.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.paymentSchedule.getIn([loanId.toString()]).data       #=> Immutable.Map
* this.props.paymentSchedule.getIn([loanId.toString()]).fetched    #=> boolean
* this.props.paymentSchedule.getIn([loanId.toString()]).pending    #=> boolean
* this.props.paymentSchedule.getIn([loanId.toString()]).error      #=> null or something returned from action
*
* @method fetchClientLoansPaymentScheduleByLoanid
*
* @param  loanId  {?}
*
* @return {fetchClientLoansPaymentScheduleByLoanid} src/common/api/response/fetchClientLoansPaymentScheduleByLoanid.js
*/


function fetchClientLoansPaymentScheduleByLoanid(loanId) {
  return function (_ref16) {
    var httpGet = _ref16.httpGet;
    return {
      type: 'FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID',
      meta: {
        loanId: loanId
      },
      payload: {
        promise: httpGet('/client/loans/' + loanId + '/payment-schedule')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientLoansPaymentScheduleByLoanid(loanId)
*/


function fetchClientLoansPaymentScheduleByLoanidReset(loanId) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_CLIENT_LOANS_PAYMENT_SCHEDULE_BY_LOANID_RESET',
    meta: {
      loanId: loanId
    },
    hardReset: hard
  };
}
/**
* GET /client/phone
*
* Load response by connectState:
* @connectState({
*   state: {
*     phone: ['api', 'fetch', 'client', 'phone', 'query']
*   },
*   actions: {
*     fetchClientPhone: ['api', 'fetchClientPhone']
*   }
* })
*
* In component you can get to query result by:
* this.props.phone.data    #=> Immutable.Map
* this.props.phone.fetched #=> boolean
* this.props.phone.pending #=> boolean
* this.props.phone.error   #=> null or something returned from action
*
* @method fetchClientPhone
*
* @return {fetchClientPhone} src/common/api/response/fetchClientPhone.js
*/


function fetchClientPhone() {
  return function (_ref17) {
    var httpGet = _ref17.httpGet;
    return {
      type: 'FETCH_CLIENT_PHONE',
      payload: {
        promise: httpGet('/client/phone')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientPhone()
*/


function fetchClientPhoneReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_PHONE_RESET',
    hardReset: hard
  };
}
/**
* GET /client/profile
*
* Load response by connectState:
* @connectState({
*   state: {
*     profile: ['api', 'fetch', 'client', 'profile', 'query']
*   },
*   actions: {
*     fetchClientProfile: ['api', 'fetchClientProfile']
*   }
* })
*
* In component you can get to query result by:
* this.props.profile.data    #=> Immutable.Map
* this.props.profile.fetched #=> boolean
* this.props.profile.pending #=> boolean
* this.props.profile.error   #=> null or something returned from action
*
* @method fetchClientProfile
*
* @return {fetchClientProfile} src/common/api/response/fetchClientProfile.js
*/


function fetchClientProfile() {
  return function (_ref18) {
    var httpGet = _ref18.httpGet;
    return {
      type: 'FETCH_CLIENT_PROFILE',
      payload: {
        promise: httpGet('/client/profile')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientProfile()
*/


function fetchClientProfileReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_PROFILE_RESET',
    hardReset: hard
  };
}
/**
* GET /client/settings
*
* Load response by connectState:
* @connectState({
*   state: {
*     settings: ['api', 'fetch', 'client', 'settings', 'query']
*   },
*   actions: {
*     fetchClientSettings: ['api', 'fetchClientSettings']
*   }
* })
*
* In component you can get to query result by:
* this.props.settings.data    #=> Immutable.Map
* this.props.settings.fetched #=> boolean
* this.props.settings.pending #=> boolean
* this.props.settings.error   #=> null or something returned from action
*
* @method fetchClientSettings
*
* @return {fetchClientSettings} src/common/api/response/fetchClientSettings.js
*/


function fetchClientSettings() {
  return function (_ref19) {
    var httpGet = _ref19.httpGet;
    return {
      type: 'FETCH_CLIENT_SETTINGS',
      payload: {
        promise: httpGet('/client/settings')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchClientSettings()
*/


function fetchClientSettingsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_SETTINGS_RESET',
    hardReset: hard
  };
}
/**
* GET /dictionary/countries
*
* Load response by connectState:
* @connectState({
*   state: {
*     countries: ['api', 'fetch', 'dictionary', 'countries', 'query']
*   },
*   actions: {
*     fetchDictionaryCountries: ['api', 'fetchDictionaryCountries']
*   }
* })
*
* In component you can get to query result by:
* this.props.countries.data    #=> Immutable.Map
* this.props.countries.fetched #=> boolean
* this.props.countries.pending #=> boolean
* this.props.countries.error   #=> null or something returned from action
*
* @method fetchDictionaryCountries
*
* @return {fetchDictionaryCountries} src/common/api/response/fetchDictionaryCountries.js
*/


function fetchDictionaryCountries() {
  return function (_ref20) {
    var httpGet = _ref20.httpGet;
    return {
      type: 'FETCH_DICTIONARY_COUNTRIES',
      payload: {
        promise: httpGet('/dictionary/countries')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchDictionaryCountries()
*/


function fetchDictionaryCountriesReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_DICTIONARY_COUNTRIES_RESET',
    hardReset: hard
  };
}
/**
* GET /dictionary/employment-statuses
*
* Load response by connectState:
* @connectState({
*   state: {
*     employmentStatuses: ['api', 'fetch', 'dictionary', 'employmentStatuses', 'query']
*   },
*   actions: {
*     fetchDictionaryEmploymentStatuses: ['api', 'fetchDictionaryEmploymentStatuses']
*   }
* })
*
* In component you can get to query result by:
* this.props.employmentStatuses.data    #=> Immutable.Map
* this.props.employmentStatuses.fetched #=> boolean
* this.props.employmentStatuses.pending #=> boolean
* this.props.employmentStatuses.error   #=> null or something returned from action
*
* @method fetchDictionaryEmploymentStatuses
*
* @return {fetchDictionaryEmploymentStatuses} src/common/api/response/fetchDictionaryEmploymentStatuses.js
*/


function fetchDictionaryEmploymentStatuses() {
  return function (_ref21) {
    var httpGet = _ref21.httpGet;
    return {
      type: 'FETCH_DICTIONARY_EMPLOYMENT_STATUSES',
      payload: {
        promise: httpGet('/dictionary/employment-statuses')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchDictionaryEmploymentStatuses()
*/


function fetchDictionaryEmploymentStatusesReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_DICTIONARY_EMPLOYMENT_STATUSES_RESET',
    hardReset: hard
  };
}
/**
* GET /dictionary/industries
*
* Load response by connectState:
* @connectState({
*   state: {
*     industries: ['api', 'fetch', 'dictionary', 'industries', 'query']
*   },
*   actions: {
*     fetchDictionaryIndustries: ['api', 'fetchDictionaryIndustries']
*   }
* })
*
* In component you can get to query result by:
* this.props.industries.data    #=> Immutable.Map
* this.props.industries.fetched #=> boolean
* this.props.industries.pending #=> boolean
* this.props.industries.error   #=> null or something returned from action
*
* @method fetchDictionaryIndustries
*
* @return {fetchDictionaryIndustries} src/common/api/response/fetchDictionaryIndustries.js
*/


function fetchDictionaryIndustries() {
  return function (_ref22) {
    var httpGet = _ref22.httpGet;
    return {
      type: 'FETCH_DICTIONARY_INDUSTRIES',
      payload: {
        promise: httpGet('/dictionary/industries')
      }
    };
  };
}
/**
* Reset state to its original state before calling fetchDictionaryIndustries()
*/


function fetchDictionaryIndustriesReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_DICTIONARY_INDUSTRIES_RESET',
    hardReset: hard
  };
}
/**
* POST /client/application
*
* Load response by connectState:
* @connectState({
*   state: {
*     application: ['api', 'send', 'client', 'application', 'query']
*   },
*   actions: {
*     sendClientApplication: ['api', 'sendClientApplication']
*   }
* })
*
* In component you can get to query result by:
* this.props.application.data    #=> Immutable.Map
* this.props.application.fetched #=> boolean
* this.props.application.pending #=> boolean
* this.props.application.error   #=> null or something returned from action
*
* @method sendClientApplication
*
* @param  params  {sendClientApplication}  src/api/request/sendClientApplication.js
*
* @return {sendClientApplication} src/common/api/response/sendClientApplication.js
*/


function sendClientApplication(params) {
  return function (_ref23) {
    var httpPost = _ref23.httpPost;
    return {
      type: 'SEND_CLIENT_APPLICATION',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/client/application', params)
      }
    };
  };
}
/**
* Reset state to its original state before calling sendClientApplication(params)
*/


function sendClientApplicationReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_APPLICATION_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
}
/**
* POST /client/cookies
*
* Load response by connectState:
* @connectState({
*   state: {
*     cookies: ['api', 'send', 'client', 'cookies', 'query']
*   },
*   actions: {
*     sendClientCookies: ['api', 'sendClientCookies']
*   }
* })
*
* In component you can get to query result by:
* this.props.cookies.data    #=> Immutable.Map
* this.props.cookies.fetched #=> boolean
* this.props.cookies.pending #=> boolean
* this.props.cookies.error   #=> null or something returned from action
*
* @method sendClientCookies
*
* @param  params  {sendClientCookies}  src/api/request/sendClientCookies.js
*
*/


function sendClientCookies(params) {
  return function (_ref24) {
    var httpPost = _ref24.httpPost;
    return {
      type: 'SEND_CLIENT_COOKIES',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/client/cookies', params)
      }
    };
  };
}
/**
* Reset state to its original state before calling sendClientCookies(params)
*/


function sendClientCookiesReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_COOKIES_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
}
/**
* POST /client/email
*
* Load response by connectState:
* @connectState({
*   state: {
*     email: ['api', 'send', 'client', 'email']
*   },
*   actions: {
*     sendClientEmail: ['api', 'sendClientEmail']
*   }
* })
*
* This action returns saves queries to nested structure with [responseToken]
* so in component you can get to query result by:
* this.props.email.getIn([responseToken.toString(), 'data'])    #=> Immutable.Map
* this.props.email.getIn([responseToken.toString(), 'fetched']) #=> boolean
* this.props.email.getIn([responseToken.toString(), 'pending']) #=> boolean
* this.props.email.getIn([responseToken.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.email.getIn([responseToken.toString()]).data       #=> Immutable.Map
* this.props.email.getIn([responseToken.toString()]).fetched    #=> boolean
* this.props.email.getIn([responseToken.toString()]).pending    #=> boolean
* this.props.email.getIn([responseToken.toString()]).error      #=> null or something returned from action
*
* @method sendClientEmail
*
* @param  responseToken  {String}
*
* @return {sendClientEmail} src/common/api/response/sendClientEmail.js
*/


function sendClientEmail(responseToken) {
  return function (_ref25) {
    var httpPost = _ref25.httpPost;
    return {
      type: 'SEND_CLIENT_EMAIL',
      meta: {
        responseToken: responseToken
      },
      payload: {
        promise: httpPost('/client/email', responseToken)
      }
    };
  };
}
/**
* Reset state to its original state before calling sendClientEmail(responseToken)
*/


function sendClientEmailReset(responseToken) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_EMAIL_RESET',
    meta: {
      responseToken: responseToken
    },
    hardReset: hard
  };
}
/**
* POST /client/identity-document
*
* Load response by connectState:
* @connectState({
*   state: {
*     identityDocument: ['api', 'send', 'client', 'identityDocument']
*   },
*   actions: {
*     sendClientIdentityDocument: ['api', 'sendClientIdentityDocument']
*   }
* })
*
* This action returns saves queries to nested structure with [responseToken]
* so in component you can get to query result by:
* this.props.identityDocument.getIn([responseToken.toString(), 'data'])    #=> Immutable.Map
* this.props.identityDocument.getIn([responseToken.toString(), 'fetched']) #=> boolean
* this.props.identityDocument.getIn([responseToken.toString(), 'pending']) #=> boolean
* this.props.identityDocument.getIn([responseToken.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.identityDocument.getIn([responseToken.toString()]).data       #=> Immutable.Map
* this.props.identityDocument.getIn([responseToken.toString()]).fetched    #=> boolean
* this.props.identityDocument.getIn([responseToken.toString()]).pending    #=> boolean
* this.props.identityDocument.getIn([responseToken.toString()]).error      #=> null or something returned from action
*
* @method sendClientIdentityDocument
*
* @param  responseToken  {String}
*
*/


function sendClientIdentityDocument(responseToken) {
  return function (_ref26) {
    var httpPost = _ref26.httpPost;
    return {
      type: 'SEND_CLIENT_IDENTITY_DOCUMENT',
      meta: {
        responseToken: responseToken
      },
      payload: {
        promise: httpPost('/client/identity-document', responseToken)
      }
    };
  };
}
/**
* Reset state to its original state before calling sendClientIdentityDocument(responseToken)
*/


function sendClientIdentityDocumentReset(responseToken) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_IDENTITY_DOCUMENT_RESET',
    meta: {
      responseToken: responseToken
    },
    hardReset: hard
  };
}
/**
* POST /client/phone
*
* Load response by connectState:
* @connectState({
*   state: {
*     phone: ['api', 'send', 'client', 'phone']
*   },
*   actions: {
*     sendClientPhone: ['api', 'sendClientPhone']
*   }
* })
*
* This action returns saves queries to nested structure with [responseToken]
* so in component you can get to query result by:
* this.props.phone.getIn([responseToken.toString(), 'data'])    #=> Immutable.Map
* this.props.phone.getIn([responseToken.toString(), 'fetched']) #=> boolean
* this.props.phone.getIn([responseToken.toString(), 'pending']) #=> boolean
* this.props.phone.getIn([responseToken.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.phone.getIn([responseToken.toString()]).data       #=> Immutable.Map
* this.props.phone.getIn([responseToken.toString()]).fetched    #=> boolean
* this.props.phone.getIn([responseToken.toString()]).pending    #=> boolean
* this.props.phone.getIn([responseToken.toString()]).error      #=> null or something returned from action
*
* @method sendClientPhone
*
* @param  responseToken  {String}
*
* @return {sendClientPhone} src/common/api/response/sendClientPhone.js
*/


function sendClientPhone(responseToken) {
  return function (_ref27) {
    var httpPost = _ref27.httpPost;
    return {
      type: 'SEND_CLIENT_PHONE',
      meta: {
        responseToken: responseToken
      },
      payload: {
        promise: httpPost('/client/phone', responseToken)
      }
    };
  };
}
/**
* Reset state to its original state before calling sendClientPhone(responseToken)
*/


function sendClientPhoneReset(responseToken) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_PHONE_RESET',
    meta: {
      responseToken: responseToken
    },
    hardReset: hard
  };
}
/**
* POST /registration
*
* Load response by connectState:
* @connectState({
*   state: {
*     registration: ['api', 'send', 'registration']
*   },
*   actions: {
*     sendRegistration: ['api', 'sendRegistration']
*   }
* })
*
* This action returns saves queries to nested structure with [responseToken]
* so in component you can get to query result by:
* this.props.registration.getIn([responseToken.toString(), 'data'])    #=> Immutable.Map
* this.props.registration.getIn([responseToken.toString(), 'fetched']) #=> boolean
* this.props.registration.getIn([responseToken.toString(), 'pending']) #=> boolean
* this.props.registration.getIn([responseToken.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.registration.getIn([responseToken.toString()]).data       #=> Immutable.Map
* this.props.registration.getIn([responseToken.toString()]).fetched    #=> boolean
* this.props.registration.getIn([responseToken.toString()]).pending    #=> boolean
* this.props.registration.getIn([responseToken.toString()]).error      #=> null or something returned from action
*
* @method sendRegistration
*
* @param  responseToken  {String}
*
* @return {sendRegistration} src/common/api/response/sendRegistration.js
*/


function sendRegistration(responseToken) {
  return function (_ref28) {
    var httpPost = _ref28.httpPost;
    return {
      type: 'SEND_REGISTRATION',
      meta: {
        responseToken: responseToken
      },
      payload: {
        promise: httpPost('/registration', responseToken)
      }
    };
  };
}
/**
* Reset state to its original state before calling sendRegistration(responseToken)
*/


function sendRegistrationReset(responseToken) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_REGISTRATION_RESET',
    meta: {
      responseToken: responseToken
    },
    hardReset: hard
  };
}
/**
* PUT /client/additional-data
*
* Load response by connectState:
* @connectState({
*   state: {
*     additionalData: ['api', 'patch', 'client', 'additionalData', 'query']
*   },
*   actions: {
*     patchClientAdditionalData: ['api', 'patchClientAdditionalData']
*   }
* })
*
* In component you can get to query result by:
* this.props.additionalData.data    #=> Immutable.Map
* this.props.additionalData.fetched #=> boolean
* this.props.additionalData.pending #=> boolean
* this.props.additionalData.error   #=> null or something returned from action
*
* @method patchClientAdditionalData
*
* @param  params  {patchClientAdditionalData}  src/api/request/patchClientAdditionalData.js
*
*/


function patchClientAdditionalData(params) {
  return function (_ref29) {
    var httpPut = _ref29.httpPut;
    return {
      type: 'PATCH_CLIENT_ADDITIONAL_DATA',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/additional-data', params)
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientAdditionalData(params)
*/


function patchClientAdditionalDataReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_ADDITIONAL_DATA_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
}
/**
* PUT /client/application
*
* Load response by connectState:
* @connectState({
*   state: {
*     application: ['api', 'patch', 'client', 'application', 'query']
*   },
*   actions: {
*     patchClientApplication: ['api', 'patchClientApplication']
*   }
* })
*
* In component you can get to query result by:
* this.props.application.data    #=> Immutable.Map
* this.props.application.fetched #=> boolean
* this.props.application.pending #=> boolean
* this.props.application.error   #=> null or something returned from action
*
* @method patchClientApplication
*
*/


function patchClientApplication() {
  return function (_ref30) {
    var httpPut = _ref30.httpPut;
    return {
      type: 'PATCH_CLIENT_APPLICATION',
      payload: {
        promise: httpPut('/client/application')
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientApplication()
*/


function patchClientApplicationReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'PATCH_CLIENT_APPLICATION_RESET',
    hardReset: hard
  };
}
/**
* PUT /client/application/check
*
* Load response by connectState:
* @connectState({
*   state: {
*     check: ['api', 'patch', 'client', 'application', 'check', 'query']
*   },
*   actions: {
*     patchClientApplicationCheck: ['api', 'patchClientApplicationCheck']
*   }
* })
*
* In component you can get to query result by:
* this.props.check.data    #=> Immutable.Map
* this.props.check.fetched #=> boolean
* this.props.check.pending #=> boolean
* this.props.check.error   #=> null or something returned from action
*
* @method patchClientApplicationCheck
*
*/


function patchClientApplicationCheck() {
  return function (_ref31) {
    var httpPut = _ref31.httpPut;
    return {
      type: 'PATCH_CLIENT_APPLICATION_CHECK',
      payload: {
        promise: httpPut('/client/application/check')
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientApplicationCheck()
*/


function patchClientApplicationCheckReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'PATCH_CLIENT_APPLICATION_CHECK_RESET',
    hardReset: hard
  };
}
/**
* PUT /client/consents
*
* Load response by connectState:
* @connectState({
*   state: {
*     consents: ['api', 'patch', 'client', 'consents', 'query']
*   },
*   actions: {
*     patchClientConsents: ['api', 'patchClientConsents']
*   }
* })
*
* In component you can get to query result by:
* this.props.consents.data    #=> Immutable.Map
* this.props.consents.fetched #=> boolean
* this.props.consents.pending #=> boolean
* this.props.consents.error   #=> null or something returned from action
*
* @method patchClientConsents
*
*/


function patchClientConsents() {
  return function (_ref32) {
    var httpPut = _ref32.httpPut;
    return {
      type: 'PATCH_CLIENT_CONSENTS',
      payload: {
        promise: httpPut('/client/consents')
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientConsents()
*/


function patchClientConsentsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'PATCH_CLIENT_CONSENTS_RESET',
    hardReset: hard
  };
}
/**
* PUT /client/email-confirmation
*
* Load response by connectState:
* @connectState({
*   state: {
*     emailConfirmation: ['api', 'patch', 'client', 'emailConfirmation', 'query']
*   },
*   actions: {
*     patchClientEmailConfirmation: ['api', 'patchClientEmailConfirmation']
*   }
* })
*
* In component you can get to query result by:
* this.props.emailConfirmation.data    #=> Immutable.Map
* this.props.emailConfirmation.fetched #=> boolean
* this.props.emailConfirmation.pending #=> boolean
* this.props.emailConfirmation.error   #=> null or something returned from action
*
* @method patchClientEmailConfirmation
*
* @param  params  {patchClientEmailConfirmation}  src/api/request/patchClientEmailConfirmation.js
*
* @return {patchClientEmailConfirmation} src/common/api/response/patchClientEmailConfirmation.js
*/


function patchClientEmailConfirmation(params) {
  return function (_ref33) {
    var httpPut = _ref33.httpPut;
    return {
      type: 'PATCH_CLIENT_EMAIL_CONFIRMATION',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/email-confirmation', params)
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientEmailConfirmation(params)
*/


function patchClientEmailConfirmationReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_EMAIL_CONFIRMATION_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
}
/**
* PUT /client/password
*
* Load response by connectState:
* @connectState({
*   state: {
*     password: ['api', 'patch', 'client', 'password']
*   },
*   actions: {
*     patchClientPassword: ['api', 'patchClientPassword']
*   }
* })
*
* This action returns saves queries to nested structure with [responseToken]
* so in component you can get to query result by:
* this.props.password.getIn([responseToken.toString(), 'data'])    #=> Immutable.Map
* this.props.password.getIn([responseToken.toString(), 'fetched']) #=> boolean
* this.props.password.getIn([responseToken.toString(), 'pending']) #=> boolean
* this.props.password.getIn([responseToken.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.password.getIn([responseToken.toString()]).data       #=> Immutable.Map
* this.props.password.getIn([responseToken.toString()]).fetched    #=> boolean
* this.props.password.getIn([responseToken.toString()]).pending    #=> boolean
* this.props.password.getIn([responseToken.toString()]).error      #=> null or something returned from action
*
* @method patchClientPassword
*
* @param  responseToken  {String}
*
*/


function patchClientPassword(responseToken) {
  return function (_ref34) {
    var httpPut = _ref34.httpPut;
    return {
      type: 'PATCH_CLIENT_PASSWORD',
      meta: {
        responseToken: responseToken
      },
      payload: {
        promise: httpPut('/client/password', responseToken)
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientPassword(responseToken)
*/


function patchClientPasswordReset(responseToken) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_PASSWORD_RESET',
    meta: {
      responseToken: responseToken
    },
    hardReset: hard
  };
}
/**
* PUT /client/phone-confirmation
*
* Load response by connectState:
* @connectState({
*   state: {
*     phoneConfirmation: ['api', 'patch', 'client', 'phoneConfirmation', 'query']
*   },
*   actions: {
*     patchClientPhoneConfirmation: ['api', 'patchClientPhoneConfirmation']
*   }
* })
*
* In component you can get to query result by:
* this.props.phoneConfirmation.data    #=> Immutable.Map
* this.props.phoneConfirmation.fetched #=> boolean
* this.props.phoneConfirmation.pending #=> boolean
* this.props.phoneConfirmation.error   #=> null or something returned from action
*
* @method patchClientPhoneConfirmation
*
* @param  params  {patchClientPhoneConfirmation}  src/api/request/patchClientPhoneConfirmation.js
*
* @return {patchClientPhoneConfirmation} src/common/api/response/patchClientPhoneConfirmation.js
*/


function patchClientPhoneConfirmation(params) {
  return function (_ref35) {
    var httpPut = _ref35.httpPut;
    return {
      type: 'PATCH_CLIENT_PHONE_CONFIRMATION',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/phone-confirmation', params)
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientPhoneConfirmation(params)
*/


function patchClientPhoneConfirmationReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_PHONE_CONFIRMATION_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
}
/**
* PUT /client/profile
*
* Load response by connectState:
* @connectState({
*   state: {
*     profile: ['api', 'patch', 'client', 'profile', 'query']
*   },
*   actions: {
*     patchClientProfile: ['api', 'patchClientProfile']
*   }
* })
*
* In component you can get to query result by:
* this.props.profile.data    #=> Immutable.Map
* this.props.profile.fetched #=> boolean
* this.props.profile.pending #=> boolean
* this.props.profile.error   #=> null or something returned from action
*
* @method patchClientProfile
*
* @param  params  {patchClientProfile}  src/api/request/patchClientProfile.js
*
*/


function patchClientProfile(params) {
  return function (_ref36) {
    var httpPut = _ref36.httpPut;
    return {
      type: 'PATCH_CLIENT_PROFILE',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/profile', params)
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientProfile(params)
*/


function patchClientProfileReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_PROFILE_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
}
/**
* PUT /client/settings
*
* Load response by connectState:
* @connectState({
*   state: {
*     settings: ['api', 'patch', 'client', 'settings']
*   },
*   actions: {
*     patchClientSettings: ['api', 'patchClientSettings']
*   }
* })
*
* This action returns saves queries to nested structure with [responseToken]
* so in component you can get to query result by:
* this.props.settings.getIn([responseToken.toString(), 'data'])    #=> Immutable.Map
* this.props.settings.getIn([responseToken.toString(), 'fetched']) #=> boolean
* this.props.settings.getIn([responseToken.toString(), 'pending']) #=> boolean
* this.props.settings.getIn([responseToken.toString(), 'error'])   #=> null or something returned from action
* or
* this.props.settings.getIn([responseToken.toString()]).data       #=> Immutable.Map
* this.props.settings.getIn([responseToken.toString()]).fetched    #=> boolean
* this.props.settings.getIn([responseToken.toString()]).pending    #=> boolean
* this.props.settings.getIn([responseToken.toString()]).error      #=> null or something returned from action
*
* @method patchClientSettings
*
* @param  responseToken  {String}
*
* @return {patchClientSettings} src/common/api/response/patchClientSettings.js
*/


function patchClientSettings(responseToken) {
  return function (_ref37) {
    var httpPut = _ref37.httpPut;
    return {
      type: 'PATCH_CLIENT_SETTINGS',
      meta: {
        responseToken: responseToken
      },
      payload: {
        promise: httpPut('/client/settings', responseToken)
      }
    };
  };
}
/**
* Reset state to its original state before calling patchClientSettings(responseToken)
*/


function patchClientSettingsReset(responseToken) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_SETTINGS_RESET',
    meta: {
      responseToken: responseToken
    },
    hardReset: hard
  };
}